
'use strict';

define('component!PulseIndicatorComponent',['require','react','react-dom','underscore','jquery','lib/react/React.PodioView','lib/Podio.Gravity','lib/Podio.Event','lib/Podio.Utils'],function (require) {
  'use strict';

  var React = require('react');
  var ReactDOM = require('react-dom');
  var _ = require('underscore');
  var $ = require('jquery');
  var PodioView = require('lib/react/React.PodioView');

  var PodioGravity = require('lib/Podio.Gravity');
  var podioEvent = require('lib/Podio.Event');
  var podioUtils = require('lib/Podio.Utils');

  var PulseIndicatorComponent = PodioView.extend({
    getInitialState: function getInitialState() {
      return {
        assignment: void 0
      };
    },

    UNSAFE_componentWillMount: function UNSAFE_componentWillMount() {
      this.gravityHelper = new PodioGravity({
        arrowSpacing: 0
      });
    },

    componentDidMount: function componentDidMount() {
      this._position();
      this._isMounted = true;
      podioEvent.bind(podioEvent.Types.resize, this._position, this);
    },

    componentWillUnmount: function componentWillUnmount() {
      podioEvent.unbind(undefined, undefined, this);
      this._isMounted = false;
    },

    componentDidUpdate: function componentDidUpdate() {
      this._position();
    },

    _position: function _position() {
      if (_.isUndefined(this.state.assignment)) {
        return;
      }

      if (_.contains(['fillTitle', 'fillDescription', 'addTextField', 'renameTextFieldToDescription', 'createItem'], this.state.assignment.id)) {
        podioUtils.timedInterval(this._calculateAndSetPosition, 16, 300);
      } else {
        this._calculateAndSetPosition();
      }
    },

    _calculateAndSetPosition: function _calculateAndSetPosition() {
      if (!this._isMounted) {
        return;
      }

      var elmNode = $(ReactDOM.findDOMNode(this));
      var elmAttachmentTarget = $(this.state.assignment.selector).eq(0);

      if (elmAttachmentTarget.length === 0) {
        elmNode.fadeOut();
        return;
      }

      var calculatedGravity = this.gravityHelper.calculateBestGravity(elmAttachmentTarget, elmNode);
      var gravity = this.state.assignment.id === 'addTextField' ? calculatedGravity : 'e';

      var gravityPosition = this.gravityHelper.calculateElementPositionByGravity(gravity, elmNode, elmAttachmentTarget, 0);

      var top = gravityPosition.position.top - 30,
          left = gravityPosition.position.left;

      if (_.contains(['enterModifyTemplate', 'createItem'], this.state.assignment.id)) {
        left = left + 20;
      }

      _.extend(gravityPosition.position, {
        top: top,
        left: left
      });

      elmNode.fadeIn().css(gravityPosition.position);
    },

    render: function render() {
      return React.createElement(
        'div',
        { className: 'pulse-indicator-component' },
        React.createElement('a', null)
      );
    }
  });

  return PulseIndicatorComponent;
});
